var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUldContainerClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.925,15.306L10.935,21.39L13.573,22.445L17.271,18.408L17.271,17.154L10.925,15.306ZM0.865,6.891L10.205,9.434L10.2,21.161L0.889,17.496L0.865,6.891ZM18.025,17.064L18.02,17.928L23.009,13.532L23.05,12.793L18.025,17.064ZM18.068,11.499L18.037,16.444L23.028,12.305L23.131,7.872L18.068,11.499ZM10.925,9.628L17.271,11.41L17.271,16.361L10.925,14.513L10.925,9.628ZM6.853,3.693L22.815,7.516L17.738,11.141L1.151,6.539L6.853,3.693Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUldContainerClosed);
export default __webpack_public_path__ + "static/media/uld-container-closed.caf81032.svg";
export { ForwardRef as ReactComponent };